module.exports = __webpack_public_path__ + "twitter-3212f25ade42e8f0ae4c.svg";